<template>
  <div class="thank">
    <div class="thankhead">
      <h4>
        <span class="iconfont">&#xe722;</span>
        {{ $t('shopping.thank_you') }}
        <i>{{ billing_address.first_name }}</i>
      </h4>
      <p>
        {{ $t('account.order') }}:
        <span>{{ order.number }}</span>
      </p>
    </div>
    <div class="thankbody">
      <div class="ordersure">
        <div>
          <h5>{{ $t('shopping.order_confirmed1') }}</h5>
          <p v-if="order.trackno">{{ $t('shopping.order_confirmed2') }}</p>
          <p v-else>{{ $t('shopping.order_confirmed') }}</p>
        </div>
        <div v-if="order.trackno">
          <h5>{{ $t('shopping.tracking_number') }}</h5>
          <p>
            <a :href="track_url">{{ order.trackno }}</a>
          </p>
        </div>
      </div>
      <!-- <div class="ordersure">
        <div>
          <h5>{{$t('shopping.order_updates1')}}</h5>
          <p>{{$t('shopping.order_updates2')}}</p>
        </div>
      </div> -->
      <div class="ordersure">
        <div>
          <h5>{{ $t('shopping.customer_info') }}</h5>
          <ul class="Customerinformation clearfix">
            <li>
              <div>{{ $t('shopping.contact_info') }}</div>
              <p>{{ billing_address.email }}</p>
            </li>
            <li v-if="order.payment_method_title">
              <div>{{ $t('shopping.payment_mothod') }}</div>
              <p v-if="order.payment_method_title != 'free_order'">
                {{ pay_method(order.payment_method, order.payment_method_title) }} -
                <v-currencysymbol></v-currencysymbol>{{ order.order_total }}
              </p>
              <p v-else>{{ $t('shopping.free') }}</p>
            </li>
            <li v-else>
              <div>{{ $t('shopping.shipping_method') }}</div>
              <p v-if="order.shippings.length">{{ order.shippings[0].order_item_name }}</p>
            </li>
            <li>
              <div>{{ $t('shopping.shipping_address') }}</div>
              <p>{{ shipping_address.first_name }} {{ shipping_address.last_name }}</p>
              <p>{{ shipping_address.address_1 }} {{ shipping_address.address_2 }} {{ shipping_address.city }}</p>
              <p>
                {{ shipping_address.postcode }}
                <span
                  v-if="this.getstate(shipping_address.state, shipping_address.country, this.myService)"
                  v-html="this.getstate(shipping_address.state, shipping_address.country, this.myService)"
                ></span>
                <span v-else>{{ shipping_address.state }} </span>
              </p>
              <p v-html="this.getcountry(shipping_address.country, this.myService)"></p>
              <p v-if="shipping_address.phone != 18065041234">{{ shipping_address.phone }}</p>
              <p v-if="shipping_address.address_note">{{ shipping_address.address_note }}</p>
            </li>
            <li>
              <div>{{ $t('shopping.billing_address') }}</div>
              <p>{{ billing_address.first_name }} {{ billing_address.last_name }}</p>
              <p>{{ billing_address.address_1 }} {{ billing_address.address_2 }} {{ billing_address.city }}</p>
              <p>
                {{ billing_address.postcode }}
                <span
                  v-if="this.getstate(billing_address.state, billing_address.country, this.myService)"
                  v-html="this.getstate(billing_address.state, billing_address.country, this.myService)"
                ></span>
                <span v-else>{{ billing_address.state }} </span>
              </p>
              <p v-html="this.getcountry(billing_address.country, this.myService)"></p>
              <p v-if="billing_address.phone != 18065041234">{{ billing_address.phone }}</p>
              <p v-if="billing_address.address_note">{{ billing_address.address_note }}</p>
            </li>
            <li v-if="order.payment_method_title" style="width: 100%">
              <div>{{ $t('shopping.shipping_method') }}</div>
              <p v-if="order.shippings.length" v-html="order.shippings[0].order_item_name"></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="needhelp clearfix">
      <div>
        <span class="iconfont">&#xe725;</span>
        <a :href="'mailto:' + email">{{ $t('shopping.need_help') }}</a>
      </div>
      <div>
        <a href="/">{{ $t('shopping.continue_shipping') }}</a>
      </div>
    </div>

    <v-checkoutcommonfoot :blogname="blogname" :PolicyPages="PolicyPages"></v-checkoutcommonfoot>
  </div>
</template>
<script>
import vCheckoutcommonfoot from '@/views/checkout/js/components/checkoutcommonfoot'
import googleAnalysis from '@/js/lib/ga'

export default {
  props: ['order', 'email', 'service', 'blogname', 'PolicyPages', 'track', 'order_tracking', 'payed'],
  data() {
    return {
      myService: [],
      availableCreditCardMethods: ['worldpay', 'nspayment', 'asiabill', 'oceanpayment', 'stripe','airwallex'],
      availablePayPalMethods: ['ppec_paypal', 'paypal_rest', 'paypal','paypal_cluster_rest'],
      availableLocalMethods: ['payssion', 'klarna_payment'],
      shipping_address: {},
      billing_address: {},
    }
  },
  beforeMount() {
    this.myService = this.service
  },
  mounted() {
    localStorage.removeItem("checkout_timeout");
    if (this.payed) {
      googleAnalysis.page({
        page_path: '/checkouts/processing',
      })

      // 谷歌分析 —— 完成支付
      googleAnalysis.event(googleAnalysis.gaAction.completedOrder, {
        page_path: '/checkouts/processing',
        transaction_id: this.order?.number,
        currency: this.order?.order_currency,
        value: this.order?.order_total,
        shipping: this.order?.order_shipping,
        coupon: this.order?.coupons?.[0]?.code,
        items: this.order?.line_items?.map((item) => ({
          id: item?.order_item_id,
          name: item?.order_item_name,
          quantity: item?.qty,
          price: item?.price,
          variant: Object.values(item?.attrs || {})?.join('/'),
        })),
      })
    } else {
      googleAnalysis.page({
        page_path: '/checkouts/thank',
      })
    }
  },
  computed: {
    track_url() {
      let url = null
      let { trackno } = this.order
      if (this.order_tracking) {
        url = `/app/order-tracking?tracknum=${trackno}`
      } else if (this.track && this.order.trackno_source && this.order.trackno_source == 'trackhub') {
        url = `/app/trackhub?tracknum=${trackno}`
      } else {
        url = `https://t.17track.net/en#nums=${trackno}`
      }
      return url
    },
  },
  methods: {
    pay_method(payment_method, payment_method_title) {
      if (
        this.availableCreditCardMethods.includes(payment_method.toLocaleLowerCase()) ||
        this.availableCreditCardMethods.includes(payment_method_title.toLocaleLowerCase())
      ) {
        return this.$t('shopping.credit_card')
      } else if (
        this.availablePayPalMethods.includes(payment_method.toLocaleLowerCase()) ||
        this.availablePayPalMethods.includes(payment_method_title.toLocaleLowerCase())
      ) {
        return 'PayPal'
      } else if (
        this.availableLocalMethods.includes(payment_method.toLocaleLowerCase()) ||
        this.availableLocalMethods.includes(payment_method_title.toLocaleLowerCase())
      ) {
        return this.$t('shopping.local_payment')
      } else {
        return payment_method
      }
    },
  },
  watch: {
    order: {
      handler(newV) {
        let { shipping_address, billing_address } = newV
        this.shipping_address = shipping_address ? shipping_address : {}
        this.billing_address = billing_address ? billing_address : {}
      },
      immediate: true,
    },
  },
  components: {
    vCheckoutcommonfoot,
  },
}
</script>
<style scoped lang='scss'>
.thank {
  .thankhead {
    h4 {
      font-size: 20px;
      span {
        color: #55c51d;
        font-size: 20px;
      }
    }
    p {
      font-size: 14px;
    }
  }
  .thankbody {
    .ordersure {
      border-radius: 5px;
      border: 1px solid #d9d9d9;
      padding: 20px;
      margin-top: 20px;
      & > :nth-child(1) {
        h5 {
          color: #333;
          font-size: 16px;
          margin-bottom: 8px;
        }
        p {
          color: #666;
          font-size: 14px;
        }
        .Customerinformation {
          padding: 0;
          list-style: none;
          li {
            width: 50%;
            float: left;
            padding-right: 20px;
            margin-top: 16px;
            div {
              font-size: 14px;
            }
            p {
              font-size: 12px;
              color: #666;
            }
          }
        }
      }
      & > :nth-child(2) {
        margin-top: 20px;
        border-top: 1px solid #d9d9d9;
        padding-top: 20px;
        h5 {
          color: #333;
          font-size: 14px;
          margin-bottom: 5px;
        }
        p {
          a {
            font-size: 14px;
            color: #013a8c;
            text-decoration: none;
          }
        }
      }
    }
  }
  .needhelp {
    padding-top: 20px;
    & > :nth-child(1) {
      padding: 10px 0;
      float: left;
      a {
        text-decoration: none;
        color: black;
      }
      span {
        font-size: 18px;
        font-weight: 600;
      }
    }
    & > :nth-child(2) {
      float: right;
      background: #0f88a7;
      border-radius: 5px;
      a {
        width: 100%;
        display: inline-block;
        color: white;
        padding: 20px;
        text-decoration: none;
      }
    }
    & > :nth-child(2):hover {
      opacity: 0.9;
    }
  }
}
@media screen and(max-width: 767px) {
  .thank {
    .thankbody {
      .ordersure {
        & > :nth-child(1) {
          .Customerinformation {
            li {
              float: none;
              width: 100%;
            }
          }
        }
      }
    }
    .needhelp {
      & > :nth-child(1) {
        float: none;
      }
      & > :nth-child(2) {
        text-align: center;
        float: none;
      }
    }
  }
}
* {
  font-style: normal;
  p {
    margin: 0;
  }
}
</style>
